export default {
  GET_CUSTOMER_PERSONALITY_PROFILE_QUERY: Symbol.for('GET_CUSTOMER_PERSONALITY_PROFILE_QUERY'),
  CUSTOMER_PERSONALITY_PROFILE_REPOSITORY: Symbol.for('CUSTOMER_PERSONALITY_PROFILE_REPOSITORY'),
  CUSTOMER_PERSONALITY_PROFILE_STATE_MANAGER: Symbol.for('CUSTOMER_PERSONALITY_PROFILE_STATE_MANAGER'),
};
